import React, { useState, useEffect } from "react";
import "../Assets/css/password.css";
import {
  handleLogin,
  SET_NOTIFICATION_TOKEN,
  showMessage,
} from "../Functionalities/Functions";

function Login() {
  const [data, setData] = useState({
    username: "",
    password: "",
  });

  const [loading, setloading] = useState(false);
  const [loggedin, setLoggedin] = useState(false);

  useEffect(() => {
    if (loggedin) {
      setNotificationToken();
    }
  }, [loggedin]);

  const setNotificationToken = () => {
    let result = SET_NOTIFICATION_TOKEN();
    result
      .then((response) => {
        window.location.replace("/");
      })
      .catch((err) => {});
  };

  const submitHandler = (e) => {
    e.preventDefault();
    setloading(true);
    let result = handleLogin(data.username, data.password);

    result
      .then((response) => {
        if (response.Status === true) {
          if (response.is_deliveryboy === true) {
            setloading(false);
            showMessage(
              "You can't log in to the admin panel",
              "danger",
              "Error!",
              "top",
              "top-right",
              0
            );
          } else {
            setloading(false);
            setLoggedin(true);
          }
        } else {
          setloading(false);
          showMessage(
            "Login failed",
            "danger",
            "Error!",
            "top",
            "top-right",
            0
          );
        }
      })
      .catch((error) => void 0);
  };

  return (
    <div className="space">
      <div className="authincation h-100">
        <div className="container h-100">
          <div className="row justify-content-center h-100 align-items-center">
            <div className="col-md-6">
              <div className="authincation-content">
                <div className="row no-gutters">
                  <div className="col-xl-12">
                    <div className="auth-form">
                      <div className="text-center mb-3">
                        <a href="/dashboard">
                          <img src="images/foodoor_white.png" alt="Foodoor" />
                        </a>
                      </div>
                      <h4 className="text-center mb-4 text-white">
                        Sign in your account
                      </h4>
                      <form>
                        <div className="form-group">
                          <label className="mb-1 text-white">
                            <strong>Username</strong>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            value={data.username}
                            onChange={(e) => {
                              setData({ ...data, username: e.target.value });
                            }}
                          />
                        </div>
                        <div className="form-group">
                          <label className="mb-1 text-white">
                            <strong>Password</strong>
                          </label>
                          <input
                            type="password"
                            className="form-control"
                            value={data.password}
                            onChange={(e) => {
                              setData({ ...data, password: e.target.value });
                            }}
                          />
                        </div>

                        {!loading ? (
                          <div className="text-center">
                            <button
                              onClick={(e) => submitHandler(e)}
                              className="btn bg-white text-primary btn-block"
                            >
                              Sign Me In
                            </button>
                          </div>
                        ) : (
                          <div
                            className="text-center btn bg-white text-primary btn-block"
                          >
                            Loading
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
